import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { INSGridConfig } from '@norfolk-southern/accessns-components';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions, RowNode } from 'ag-grid-community';

import { NSCommons } from '@ruby/configs/common.constants';
import { NSEBillConstants } from '@ruby/configs/ebill.constants';
import { IEBillDispute } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-dispute',
  templateUrl: './ebill-dispute.component.html',
  styleUrls: ['./ebill-dispute.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EBillDisputeComponent {
  @Input() data!: Array<IEBillDispute>;
  @Input() loading!: boolean;
  @Input() isDisputeDisabled!: boolean;
  @Output() disputeBill = new EventEmitter<Array<IEBillDispute>>();
  @Output() resetHeader = new EventEmitter();
  gridConfig: INSGridConfig = NSEBillConstants.gridConfig;
  gridOptions: GridOptions = NSEBillConstants.disputeGridOptions;
  grid!: AgGridAngular;

  constructor(private location: Location) { }

  /**
   * Set Up Grid
   *
   * @summary Sets the Grid reference and filter
   * @param $grid: AgGridAngular
   * @return void
   */
  setUpGrid($grid: AgGridAngular): void {
    this.grid = $grid;
  }

  /**
   * dispute Bills
   *
   * @summary dispute bills with selected reason and comment
   * @return void
   */
  disputeBills(): void {
    const data: Array<IEBillDispute> = [];
    this.grid.api.forEachNode((node: RowNode) => {
      data.push({
        ...node.data,
        waybillDate: Number(NSCommons.formatNSDate(node.data.waybillDate, 'yyyyMMdd')),
        originBillDate: Number(NSCommons.formatNSDate(node.data.originalBillDate, 'yyyyMMdd')),
        customerNumber: Number(node.data.customerNumber)
      });
    });
    this.disputeBill.emit(data);
  }

  /**
   * navigate Back
   *
   * @summary return to bill details
   * @return void
   */
  navigateBack(): void {
    this.location.back();
  }

  /**
   * Reset Grid
   *
   * @summary reset cell selection
   * @return void
   */
  resetGrid(): void {
    this.resetHeader.emit();
    this.grid.gridOptions.context.reasonCheckCount = 0;
    this.grid.gridOptions.context.commentCheckCount = 0;
    this.grid.api.setRowData(this.data);
  }
}
